import React from 'react';
import { NavLink } from 'react-router-dom';
import { LayoutDashboard, Store, Banknote, Plus, UsersRound } from 'lucide-react';
import { useApi } from '../lib/api';

export const PartnerSidebarLink = ({ mobile = false, onNavigate }) => {
  const { data } = useApi('/partner/capability');
  if (!data?.enabled && !data?.hasHistory) return null;
  return <NavLink data-testid={mobile ? 'mobile-nav-partner' : 'nav-partner'} to="/app/partner" onClick={onNavigate} className={({ isActive }) => `shop-nav-link ${isActive ? 'is-active' : ''}`}><UsersRound size={18} /><span>Partner Management</span></NavLink>;
};

export const PartnerNavigation = ({ enabled }) => <nav data-testid="partner-section-navigation" className="flex flex-wrap gap-2 mb-6 border-b border-slate-200 pb-4">
  {[
    ['/app/partner', 'Overview', LayoutDashboard, true],
    ['/app/partner/shops', 'My registered shops', Store],
    ['/app/partner/commissions', 'Commission history', Banknote],
    ...(enabled ? [['/app/partner/register', 'Register new shop', Plus]] : []),
  ].map(([path, label, Icon, end]) => <NavLink key={path} end={end} data-testid={`partner-nav-${path.split('/').pop()}`} to={path} className={({ isActive }) => `inline-flex items-center gap-2 text-sm px-3 py-2 rounded-md transition-colors ${isActive ? 'bg-emerald-700 text-white' : 'text-slate-600 hover:bg-slate-100'}`}><Icon size={16} />{label}</NavLink>)}
</nav>;